import { profileConstants, userConstants } from "../_constants";
import { userService, ServiceUtil, AccountAPI, LoanInfoApi,ProfileApi , SessionService} from "../_services";
import { alertActions, profileActions } from "./";
import { history } from "../_helpers";
import { documentConstants } from "../_constants/documents.constants";

export const userActions = {
  login,
  logout,
  register,
  sendDeviceAuthCode,
  getDeviceAuthCode,
  updateAppLanguage,
  setAppLanguage,
  handleRedirectFromLogin,
    handleLoginWithHash,
  updateAppOnlineDisclosure,
};

function login(username, password, mfaRequest, saveDevice) {
  return (dispatch,getState) => {
    dispatch(request({ username }));
    userService.login(username, password, mfaRequest).then(
      (user) => {
        //todo: look at the user data that is comig back, specifically the messageId to check if the login was really a success
        if (user.status === 2) {
          if (mfaRequest) {
            dispatch(deviceAuthFailure(mfaRequest.tokenId));
          } else {
            dispatch(mfaRequired());
          }
        } else if (user.status <= 1) {
          let messageId = user.data.messageId;
          if (messageId === 1) {
            SessionService.clearSession();
            sessionStorage.setItem("user", JSON.stringify(user.data));
            
            if (mfaRequest) {
              ServiceUtil.setDeviceId(
                userService.getUserClaim(userService.CLAIM_DEVICE_ID),
                saveDevice
              );
            }
            if (userService.userHasScope(userService.SCOPE_USER_READ)) { 
              const {users} = getState();             
              if(users.redirectToRefinance === true){   
                dispatch({type : userConstants.USERS_REDIRECT_TO_REFINANCE_LOAN_SUCCESS})
                dispatch(success(user));
                history.push("/Refinance/SelectLoan");
              }else if(users.loginHash != null){
                ProfileApi.getExtendedProfileInfo()
                  .then(result => result.data)
                  .then(data => {

                    LoanInfoApi.isValidLoginHash(
                        {
                          token : users.loginHash,
                          userHash : data.userHash
                        })
                      .then(result => {
                        dispatch(success(user));
                        if(result.data.isValid === true){
                          dispatch({type : userConstants.USERS_REDIRECT_TO_REFINANCE_LOAN_SUCCESS})
                          history.push("/Refinance/SelectLoan");
                        }else{
                          history.push("/my-account");
                        }
                    })
                  })
                
              }
              else{
                dispatch(profileActions.loadProfile())
                dispatch(success(user));
                  history.push("/my-account");                 
              }
            } else {
              dispatch(success(user));
              dispatch(profileActions.loadProfile())
              // get the flags for the account
              var suspendedFlag = userService.getUserClaim(
                userService.CLAIM_SUSPENDED_FLAG
              );

              //taking action(s) based on the values in the flags
              if (suspendedFlag === userService.TRUE) {
                history.push("/SuspendedFlag");
              }
            }
          } else {
            dispatch(failure(user.data.message));
          }
        } else {
          dispatch(failure(user.message));
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function deviceAuthFailure(deviceTokenId) {
    return {
      type: userConstants.LOGIN_DEVICE_AUTH_FAILURE,
      deviceTokenId: deviceTokenId,
    };
  }
  function mfaRequired() {
    return { type: userConstants.LOGIN_DEVICE_AUTH_REQUIRED };
  }
  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}
function getDeviceAuthCode() {
  return { type: userConstants.LOGIN_DEVICE_AUTH_FAILURE };
}
function sendDeviceAuthCode(email, mfaOption) {
    return (dispatch) => {
        var x = userService.getUserLanguage();
    AccountAPI.sendAuthorizeDeviceMfa(email, mfaOption, userService.getUserLanguage()).then((response) => {
      if(response.httpResponseCode === 200) {
        dispatch(success(response.data.tokenId, response.message));
      } else {
        throw new Error("Failed to Authenticate email token");
      }
    }).catch(error => {
      dispatch(failure(error));
    });

    function success(tokenId, message) {
      return {
        type: userConstants.LOGIN_SEND_DEVICE_AUTH_CODE,
        deviceTokenId: tokenId,
      };
    }
    function failure(errorString) {
      return {
        type: userConstants.LOGIN_DEVICE_AUTH_FAILURE,
        errorString
      }
    }
  };
}
function logout() {
  return (dispatch) => {
    if (userService.getCurrentUser()) {
      SessionService.clearSession();
      userService.logout();
    }
    dispatch(cleanDocumentsState());
    dispatch(cleanProfileState());
    dispatch(success());
  }
  function success() {
    return { type: userConstants.LOGOUT };
  }
  function cleanDocumentsState() {
    return { type: documentConstants.CLEAN_DOCUMENTS_STATE };
  }
  function cleanProfileState() {
    return { type: profileConstants.CLEAN_PROFILE_STATE };
  }
}
 

// function logout() {
//   if (userService.getCurrentUser()) {
//     SessionService.clearSession();
//     userService.logout();
//   }
//   return { type: userConstants.LOGOUT };
// }

function register(user) {
  return (dispatch) => {
    dispatch(request(user));

    userService.register(user).then(
      (user) => {
        dispatch(success());
        history.push("/login");
        dispatch(alertActions.success("Registration successful"));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(user) {
    return { type: userConstants.REGISTER_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.REGISTER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, error };
  }
}

function updateAppLanguage() {

  return (dispatch) => {
    console.log("updateAppLanguage was triggered",userService.getUserLanguage())
    if(userService.getUserLanguage() === userService.LANGUAGES.EN) {
      userService.setUserLanguage(userService.LANGUAGES.ES)
    } else {
      userService.setUserLanguage(userService.LANGUAGES.EN)
    }
    dispatch(success())
    }
  
  function success() {
    return {type: userConstants.SET_LANGUAGE}
  }
}

function updateAppOnlineDisclosure() {
    return (dispatch => {
        dispatch(request());
        userService.fetchOnlineDisclosures()
            .then((disclosures) => {
                return dispatch(success(disclosures.data));
            })
    })
    function request() {
        return { type: userConstants.GET_DISCLOSURES }
    }
    function success(disclosure) {
        return { type: userConstants.SET_DISCLOSURES, disclosure }
    }
}

function setAppLanguage(language) {
    return (dispatch) => {
        userService.setUserLanguage(language);
        return dispatch(success());
    }

    function success() {
        return { type: userConstants.SET_LANGUAGE }
    }
}

function handleRedirectFromLogin(){
  return dispatch => {
      return dispatch(success());
  };
  function success() {
    return {type: userConstants.USERS_REDIRECT_TO_REFINANCE_LOAN_REQUEST}
  }
}
function handleLoginWithHash(loginHash){
  return dispatch => {
      return dispatch(success());
  };
  function success() {
    return {type: userConstants.LOGIN_WITH_HASH,loginHash}
  }
}